import { useMemo } from 'react';
import useStudioGroup from '../../../../../../hooks/useStudioGroup';

export const linkColumnOptions = {
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  PASSWORD: 'PASSWORD',
  EMAIL: 'EMAIL',
  USERNAME: 'USERNAME',
  DONT_LINK: 'DONT_LINK',
};

export const SELECTION_COLUMN = 'SELECTION';
export const ACTIONS_COLUMN = 'ACTIONS';

export const useImportMemberColumns = () => {
  const studioGroup = useStudioGroup();

  const linkOptions = useMemo(() => {
    const options = [
      linkColumnOptions.FIRST_NAME,
      linkColumnOptions.LAST_NAME,
      linkColumnOptions.PASSWORD,
      linkColumnOptions.EMAIL,
      linkColumnOptions.USERNAME,
    ];

    if (studioGroup === 'BAO') {
      return options.filter(option => option !== linkColumnOptions.EMAIL);
    }

    return options;
  }, [studioGroup]);

  const columns = useMemo(() => {
    return [SELECTION_COLUMN, ...linkOptions, ACTIONS_COLUMN];
  }, [linkOptions]);

  return { columns, linkOptions };
};
